export const infoBlocksData = [
  {
    id: '1',
    slug: 'sales',
    icon: '👥',
  },
  {
    id: '2',
    slug: 'warranty',
    icon: '🏆',
  },
  {
    id: '3',
    slug: 'personalization',
    icon: '🎨',
  },
  {
    id: '4',
    slug: 'shipping',
    icon: '🚚',
  },
  {
    id: '5',
    slug: 'made.in.ua',
    icon: '🇺🇦',
  },
  {
    id: '6',
    slug: 'designs',
    icon: '✨',
  },
];
